/* eslint-disable valid-jsdoc */
/* eslint-disable camelcase */
import Configuration from "../key-configuration/configuration.json5";

export default class FeedbackLink {
  /**
   * @param {string} URL
   * @returns link
   * replace {AND} with &
   */
  static HandleAmpercend(value) {
    return value.toString().replace(/{AND}/g, "&");
  }

  /**
   * @param {string} _page claim summeries & claim overview page send feedback request
   * @param {string} lang
   * @returns link
   */
  static getLink(_page, lang) {
    const feedbackLinkEn = _page === 'DI6' ? Configuration.surveyLinkDI6.en : Configuration.surveyLinkClaim.en;
    const feedbackLinkFr = _page === 'DI6' ? Configuration.surveyLinkDI6.fr : Configuration.surveyLinkClaim.fr;
    if (lang === "fr") {
      return this.HandleAmpercend(feedbackLinkFr);
    }
    return this.HandleAmpercend(feedbackLinkEn);
  }

  /**
   * @param {string} page
   * @param {string} lang
   * @returns content
   */
  static feedbackLink_claims(page, lang) {
    if (lang === "fr") {
      return `

        <!DOCTYPE html>
        <html lang="en">
        
        <head>
            <title>Feedback</title>
            <meta http-equiv="X-UA-Compatible" content="IE=edge">
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1">
            <link href="https://fonts.googleapis.com/css2?family=Muli:ital,wght@0,200..1000;1,200..1000&display=swap" rel="stylesheet">
            <style>
                
                .feedbackButton {
                    position: fixed;
                    background-color: #003359;
                    font-family: "Mulish", sans-serif;
                    border: 2px solid white; 
                    border-radius: 16px;
                    right: -40px;
                    border-left:0;
                    padding:40px 12px 40px 52px; 
                    writing-mode:vertical-rl;
                    text-orientation:mixed; 
                    transform: rotate(-180deg);
                    z-index: 99999;
                }
                .feedbackLabel {
                    text-align: center;
                    color: white;
                }
                .feedbackButton:hover, .feedbackButton:focus{
                    text-decoration: underline white!important;
                }
                
                @media (min-width: 768px) {
                   	.feedbackButton {
				              top: unset;
			              }
			          }

                @media (max-width: 540px) {
			            .feedbackButton {
				            border-radius: 16px;
				            top: unset;
				            right: -24px;
				            padding:32px 6px 32px 30px;
			            }
                }
            </style>
        </head>
        
        <body>
            <a class="feedbackButton" target="_blank" title="Le lien de rétroaction s’ouvre dans un nouvel onglet" aria-label="Le lien de rétroaction s’ouvre dans un nouvel onglet" href="${this.getLink(
        page,
        lang
      )}" >
                    <div class="feedbackLabel">Sondage</div>
              </a>
        </body>
        </html>
    `;
    }
    return `
        <!DOCTYPE html>
        <html lang="en">
        <head>
        <meta name="viewport" content="width=device-width, initial-scale=1">
        <meta charset="utf-8">
        <link href="https://fonts.googleapis.com/css?family=Muli&amp;display=swap" rel="stylesheet">
        <link href="https://fonts.googleapis.com/css?family=Muli:800&amp;display=swap" rel="stylesheet">
        <meta http-equiv="X-UA-Compatible" content="IE=edge"> 
        <style>
                
              .feedbackButton {
                    position: fixed;
                    background-color: #003359;
                    font-family: "Mulish", sans-serif;
                    border: 2px solid white; 
                    border-radius: 16px;
                    right: -40px;
                    border-left:0;
                    padding:40px 12px 40px 52px; 
                    writing-mode:vertical-rl;
                    text-orientation:mixed; 
                    transform: rotate(-180deg);
                    z-index: 99999;
                }
                .feedbackLabel {
                    text-align: center;
                    color: white;
                }
                .feedbackButton:hover, .feedbackButton:focus{
                    text-decoration: underline white!important;
                }
                
                @media (min-width: 768px) {
                   	.feedbackButton {
				              top: unset;
			              }
			          }

                @media (max-width: 540px) {
			            .feedbackButton {
				            border-radius: 16px;
				            top: 60% !important;
				            right: -26px;
				            padding:32px 6px 32px 30px;
			            }
                }
  </style>
</head>
<body>
    <a class="feedbackButton" href="${this.getLink(
      page,
      lang
    )}" target="_blank" title="Feedback link opens in a new tab" aria-label="Feedback link opens in a new tab">
         <div class="feedbackLabel">Feedback</div>
    </a>        
</body>
</html>

    `;
  }
}
